.competitions {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
}

.tabs {
  border-bottom: 1px solid var(--pgm-sys-color-outline-variant);
  display: flex;
  overflow-x: auto;
}

.tab {
  background: none;
  border: 0;
  border-bottom: 2px solid transparent;
  color: var(--pgm-sys-color-on-surface-variant);
  cursor: pointer;
  flex: 1 1 auto;
  padding: var(--pgm-sys-spacing-3) var(--pgm-sys-spacing-4);
  white-space: nowrap;
}

.tab:hover {
  background-color: var(--pgm-sys-color-surface-container-low);
}

.tab:focus-visible {
  outline: 3px solid var(--pgm-sys-color-secondary);
  outline-offset: -3px;
}

.tabActive {
  border-bottom-color: var(--pgm-sys-color-primary);
  color: var(--pgm-sys-color-on-surface);
}

.panel {
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-4);
}

.caption {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.tableWrapper {
  border: 1px solid var(--pgm-sys-color-outline-variant);
  border-radius: 8px;
  overflow-x: auto;
}

.table {
  border-collapse: collapse;
  margin: 0;
  min-width: 640px;
  width: 100%;

  th,
  td {
    box-sizing: border-box;
    height: 40px;
    padding: var(--pgm-sys-spacing-1) var(--pgm-sys-spacing-4);
    text-align: left;
    vertical-align: middle;
  }

  thead th {
    background-color: var(--pgm-sys-color-surface-container-high);
    color: var(--pgm-sys-color-on-surface-variant);
    font-weight: inherit;
  }

  tbody th,
  tbody td {
    color: var(--pgm-sys-color-on-surface);
    font-weight: inherit;
  }

  tr {
    border-bottom: 1px solid var(--pgm-sys-color-outline-variant);
  }

  tbody tr:last-child {
    border-bottom: 0;
  }
}

.dateCol {
  width: 300px;
}
